import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  const { currentUser, isConfigured } = useAuth();

  // If Firebase not configured, show warning
  if (!isConfigured) {
    return (
      <div className='min-h-screen bg-[#FFB7CE] flex items-center justify-center px-4'>
        <div className='bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md text-center'>
          <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded'>
            <p className='font-bold'>⚠️ Firebase Not Configured</p>
            <p className='text-sm mt-2'>
              Please set up Firebase configuration to use the admin portal.
            </p>
          </div>
          <a 
            href='/login'
            className='inline-block mt-4 bg-[#FFB7CE] text-white px-6 py-2 rounded-lg hover:bg-[#FF9BB8] transition-colors'
          >
            Go to Login
          </a>
        </div>
      </div>
    );
  }

  // If not logged in, redirect to login
  if (!currentUser) {
    window.location.href = '/login';
    return null;
  }

  // If logged in, show the protected content
  return children;
}